import { Injectable } from '@angular/core';
import { Actions, createEffect } from '@ngrx/effects';



@Injectable()
export class UserEffects {



  constructor(private actions$: Actions) {}

}
